export type ContactAgreementValues = (typeof contactAgreementValues)[number];

// PTS-287: tylko "enabled" — "disabled" natychmiast wycofałby w Synerise zgodę daną wcześniej na ten profil.
export const contactAgreementValues = ["enabled"] as const;

export const dntCookieName = "_snrs_dnt";

export const dntCookieOptions = {
  expires: 365,
} as const;

export const srVendorName = "Synerise";
export const SYNERISE_HEALTH_TIMEOUT_MS = 5_000;
